import { createFileRoute } from '@tanstack/react-router';

import { ReCaptchaProvider } from '#features/form';
import { AccountSettings } from '#modules/user/features/profile/components/AccountSettings';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/account'
)({
  component: RouteComponent,
  ssr: false,
});

// Капча нужна трём формам этой страницы: смена пароля, смена email и удаление аккаунта.
function RouteComponent() {
  return (
    <ReCaptchaProvider>
      <AccountSettings />
    </ReCaptchaProvider>
  );
}
